export default __webpack_public_path__ + "static/media/Vector2.4d241d7d.svg";